import { render, staticRenderFns } from "./pop_preview_notice.vue?vue&type=template&id=758a0707&scoped=true&"
import script from "./pop_preview_notice.vue?vue&type=script&lang=js&"
export * from "./pop_preview_notice.vue?vue&type=script&lang=js&"
import style0 from "./pop_preview_notice.vue?vue&type=style&index=0&id=758a0707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758a0707",
  null
  
)

export default component.exports